import { useEffect } from 'react'
import { Card, Form, Input, Button, message, Alert } from 'antd'
import { useMutation, useQuery } from '@tanstack/react-query'
import { getDocsWhitelist, updateDocsWhitelist } from '../api/admin'

const Settings = () => {
  const [form] = Form.useForm()

  const { data, isLoading } = useQuery({
    queryKey: ['docs-whitelist'],
    queryFn: () => getDocsWhitelist().then((res) => res.data.data),
  })

  const mutation = useMutation({
    mutationFn: (whitelist: string) => updateDocsWhitelist(whitelist),
    onSuccess: () => {
      message.success('白名单已更新')
    },
    onError: (error: any) => {
      message.error(error.response?.data?.error || '更新失败')
    },
  })

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        whitelist: data.kvValue || '',
      })
    }
  }, [data, form])

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>系统设置</h2>
      <Card title="API 文档访问白名单">
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
          message="说明"
          description="优先使用 Worker 环境变量 DOCS_IP_WHITELIST；若未设置则使用此处保存的 KV 值。多个 IP 用英文逗号分隔。"
        />
        <Form form={form} layout="vertical" onFinish={(values) => mutation.mutate(values.whitelist || '')}>
          <Form.Item label="当前环境变量值">
            <Input value={data?.envValue || ''} disabled placeholder="未设置" />
          </Form.Item>
          <Form.Item name="whitelist" label="KV 白名单">
            <Input.TextArea rows={4} placeholder="例如: 1.2.3.4,5.6.7.8 或 *" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={mutation.isPending || isLoading}>
            保存
          </Button>
        </Form>
      </Card>
    </div>
  )
}

export default Settings
